import React from 'react';
import { HelpCircle, Route } from 'lucide-react';

interface TourLauncherProps {
  /** اجرای تورِ تعاملیِ گام‌به‌گام. */
  onStartTour: () => void;
  /** درصورت ارائه، دکمه‌ی ثانویه‌ی «راهنمای کامل» (Modal متنی) هم نمایش داده می‌شود. */
  onOpenGuide?: () => void;
  /** مقدارِ data-tour روی دکمه‌ی راهنما تا قدمِ آخرِ تور بتواند به آن اشاره کند. */
  guideButtonTourId?: string;
  className?: string;
  /** برچسبِ دکمه‌ی اصلی. پیش‌فرض: «شروع آموزش». */
  startLabel?: string;
  /** برچسبِ دکمه‌ی راهنما. پیش‌فرض: «راهنمای کامل». */
  guideLabel?: string;
}

/**
 * دکمه‌های مشترکِ راه‌اندازیِ تور برای همه‌ی داشبوردها:
 *  - «شروع آموزش» (CTA اصلی، پُر) → تورِ تعاملی را اجرا می‌کند.
 *  - «راهنمای کامل» (ثانویه، ghost) → اختیاری؛ یک Modal متنی باز می‌کند.
 *
 * با ارائهٔ یکدستِ ظاهر و رفتار در تمامِ داشبوردها، تجربهٔ یکپارچه می‌سازد.
 */
const TourLauncher: React.FC<TourLauncherProps> = ({
  onStartTour,
  onOpenGuide,
  guideButtonTourId,
  className = '',
  startLabel = 'شروع آموزش',
  guideLabel = 'راهنمای کامل',
}) => (
  <div className={`inline-flex flex-wrap items-center gap-2 ${className}`}>
    {/* CTA اصلی: تورِ تعاملیِ گام‌به‌گام */}
    <button
      type="button"
      onClick={onStartTour}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-accent-purple text-text-inverse text-sm font-semibold shadow-sm transition-all hover:shadow-lg hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-accent-purple"
      aria-label={`${startLabel} گام‌به‌گام داشبورد`}
    >
      <Route size={18} />
      {startLabel}
    </button>

    {/* دکمه‌ی ثانویه‌ی سبک (ghost): راهنمای کامل */}
    {onOpenGuide && (
      <button
        type="button"
        data-tour={guideButtonTourId}
        onClick={onOpenGuide}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-xl text-accent-purple text-sm font-medium transition-all hover:bg-accent-purple/10 focus:outline-none focus:ring-2 focus:ring-accent-purple"
        aria-label={`${guideLabel} استفاده از داشبورد`}
      >
        <HelpCircle size={18} />
        {guideLabel}
      </button>
    )}
  </div>
);

export default TourLauncher;
